import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { fetchWebCity, saveWebCity } from '../../actions/web-cities';
import { fetchWebCountries } from '../../actions/web-countries';
import { fetchCities } from '../../actions/cities';
import { resetError } from '../../actions/errors';
import WebCityForm from './form';

class WebCityEdit extends React.Component {
  componentWillMount() {
    const { getCities, getWebCity, getWebCountries } = this.props;
    getWebCity();
    getCities();
    getWebCountries();
  }

  render() {
    const {
      cities, city, goToShow, resetErrorAction, saveAction, webCountries,
    } = this.props;
    if (!city || Object.keys(city).length === 0) return null;
    const submit = (body) => {
      resetErrorAction();
      return saveAction(body).then((result) => {
        if (result.ok) goToShow();
        return result;
      });
    };
    return (
      <WebCityForm
        cities={cities}
        webCountries={webCountries}
        city={city}
        title={`Edit web city: ${city.id}`}
        submitLabel="Save"
        onSubmit={submit}
        cancel={goToShow}
      />
    );
  }
}

WebCityEdit.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.object),
  city: PropTypes.shape({}),
  getCities: PropTypes.func.isRequired,
  getWebCity: PropTypes.func.isRequired,
  getWebCountries: PropTypes.func.isRequired,
  goToShow: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
  saveAction: PropTypes.func.isRequired,
  webCountries: PropTypes.arrayOf(PropTypes.object),
};

WebCityEdit.defaultProps = { cities: [], city: {}, webCountries: [] };

const mapStateToProps = ({ cities, webCities, webCountries }) => ({
  cities: cities.items,
  city: webCities.item,
  webCountries: webCountries.items,
});
const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  getCities: () => fetchCities(),
  getWebCity: () => fetchWebCity(ownProps.match.params.id),
  getWebCountries: () => fetchWebCountries(),
  goToShow: () => push(`/web-cities/${ownProps.match.params.id}`),
  resetErrorAction: () => resetError(),
  saveAction: body => saveWebCity(ownProps.match.params.id, body),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCityEdit);
